
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AirwayAttributes } from '../../../typings/features/airway-attributes';
import { AbstractDetailComponent } from '../abstract-detail.component';

@Component({
  selector: 'jmkw-airway-detail',
  standalone: true,
  imports: [],
  templateUrl: './airway-detail.component.html',
  styleUrls: ['./airway-detail.component.scss', '../nav-widgets.shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AirwayDetailComponent extends AbstractDetailComponent<AirwayAttributes> {
  @Input() attributes!: AirwayAttributes;
}
